
export const MuiRadio = {
    styleOverrides: {
        root: {
            "& .MuiSvgIcon-root": {
                fontSize: '1rem'
            },
            "&:hover": {
                color: 'var(--mui-palette-primary-main)'
            }
        }
    }
}
